/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ZodiacTaurus = [
  ["circle", { cx: "12", cy: "15", r: "6" }],
  ["path", { d: "M18 3A6 6 0 0 1 6 3" }]
];

export { ZodiacTaurus as default };
//# sourceMappingURL=zodiac-taurus.js.map
